module.exports = __webpack_public_path__ + "static/media/spain.999219e3.svg";